import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation sendOTP($email: String!) {
    sendOTP(email: $email)
  }
`;

export type Variables = {
  readonly email: string;
};

export const useSendOTPMutation = (
  options: MutationHookOptions<Response, Variables>,
) => useMutation<Response, Variables>(MUTATION, options);
